import Innerbannerlines from "@/../../public/images/inner-banner-lines.svg";
import Logoicon from "@/../../public/images/fav-icon.svg";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Accordion from 'react-bootstrap/Accordion';
import { faqApi } from "../service/apis/faq.api";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../common/Loader/loader";

const FaqScreen = () => {
    const navigate = useNavigate();
    const [responseData, setResponseData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const faqLists = async() => {
        setIsLoading(true);
        try {
            const response = await faqApi();
            setResponseData(response.faqs.faqs);
        } catch (error) {
            console.error("Catch Error: ", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        faqLists();
    }, []);

    const decodeHtml = (html = "") => {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    };

    const sanitizeData = (htmldata = "") => {
        const sanitizedDescription = decodeHtml(htmldata);
        //console.log(sanitizedDescription);
        return (
            <div dangerouslySetInnerHTML={{ __html: sanitizedDescription }}></div>
        );
    };

    return (
        <>
            {/* <HeaderScreen /> */}
            <div className="front-pages">
                <section className="home-banner innerBanner position-relative common-padd-xl">
                    <div className="homeLine"><img src={Innerbannerlines} alt="line icon" /></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="innerBanner-info text-center">
                                    <h1>Frequently Asked Questions</h1>
                                    <div className="breadcrumb-holder text-center">
                                        <Breadcrumb>
                                            <Breadcrumb.Item onClick={() => navigate('/')}><img src={Logoicon} alt="logo icon" /> Home</Breadcrumb.Item>
                                            <Breadcrumb.Item active>FAQ's</Breadcrumb.Item>
                                        </Breadcrumb>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {isLoading ? (
                    <Loader />
                ) : (
                    <section className="faqs-area common-padd-xl pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-10 offset-lg-1">
                                    <div className="accordion-holder">
                                        <Accordion defaultActiveKey="tb-0" flush>
                                            {responseData ? ( responseData.map((resp: any, index: any) => (
                                                <Accordion.Item eventKey={`tb-${index}`} key={index}>
                                                    <Accordion.Header>{resp?.question} </Accordion.Header>
                                                    <Accordion.Body>
                                                        {sanitizeData(resp?.answer)}
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                                ))
                                            ) : (
                                                <Loader />
                                            )}
                                        </Accordion>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                )}
            </div>
            {/* <FooterScreen /> */}
        </>
    )
}
export default FaqScreen;